import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from "react"
import useDataApi from "../hooks/useDataApi"
import { fnListBlocks } from "../services/blocks"
import { BlocksContext } from "./Blocks"

export const FilterContext = createContext({})

export default function FilterProvider({ children }) {
  const [oBlockData, fnOBlockData] = useDataApi(fnListBlocks)
  const [aFilters, fnSetAFilters] = useState([])
  const [oFilterData, fnSetOFilterData] = useState({})
  const [bFilterIsActive, fnSetBFilterIsActive] = useState(false)
  const [bFilterModalIsOpen, fnSetBFilterModalIsOpen] = useState(false)
  /* const { oCurrentBoard } = useContext(BoardContext) */
  const [oCurrentBoard, fnSetOCurrentBoard] = useState(null)
  const { fnSetOparams } = useContext(BlocksContext)

  const fnPrepareFilters = async (oFilterData, aAllFieldsFiltered, cb = null) => {
    //transformar data em um array de arrays
    fnSetOFilterData(() => oFilterData)
    const aData = Object.entries(oFilterData)

    //transformar um array de arrays em um objeto

    const oData = {}
    aData.forEach((item) => {
      oData[item[0]] = item[1] || ""
    })

    //remover "model-field-" do nome dos campos com regex
    const oDataWithoutPrefix = {}
    Object.entries(oData).forEach((item) => {
      const key = item[0].replace(/model-field-/g, "")
      oDataWithoutPrefix[key] = item[1]
    })

    //juntar o valor dos campos com o final '-start' e '-end'
    const oDataWithStartEnd = {}
    Object.entries(oDataWithoutPrefix).forEach((item) => {
      const key = item[0].replace(/-start|-end|-select|-people|-number|-responsible/g, "")

      if (item[0].includes("-start") && !oDataWithStartEnd[key]) {
        oDataWithStartEnd[key] = [item[1]]
        return
      } else if (item[0].includes("-start") && oDataWithStartEnd[key]) {
        //se o campo já existir, remover o indice 0 e adicionar o valor no indice 0
        oDataWithStartEnd[key].shift()
        oDataWithStartEnd[key].unshift(item[1])
        return
      } else if (item[0].includes("-end") && oDataWithStartEnd[key]) {
        oDataWithStartEnd[key].push(item[1])
        return
      } else if (item[0].includes("-end") && !oDataWithStartEnd[key]) {
        oDataWithStartEnd[key] = ["", item[1]]
        return
      } else if (item[0].includes("-select")) {
        oDataWithStartEnd[key] = { opfv_cvalue: item[1].value, bIsSelect: true }
        return
      } /* else if (item[0].includes("-people")) {
        oDataWithStartEnd[key] = {
          opfv_cvalue: item[1].map((user) => user.value),
          bIsPeople: true,
        }
        return
      }  */ else if (item[0].includes("-number")) {
        oDataWithStartEnd[key] = { opfv_cvalue: item[1], bIsNumber: true }
        return
      } else if (item[0].includes("-responsible")) {
        oDataWithStartEnd[key] = {
          opfv_cvalue:
            item[1].length > 0 ? item[1].map((user) => user.value) : item[1].value,
          bIsPeople: true,
        }
        return
      } else {
        oDataWithStartEnd[key] = item[1]
        return
      }
    })

    //criar um array de objetos onde cada objeto tem duas chaves: opfv_opfd_nid e opfv_cvalue. opfv_opfd_nid é o nome do campo e opfv_cvalue é o valor do campo e remover os campos c

    const aDataWithNid = []
    Object.entries(oDataWithStartEnd).forEach((item) => {
      if (isNaN(item[0])) {
        aDataWithNid.push({
          opfv_opfd_nid: Number(
            aAllFieldsFiltered.find((field) => field.opfd_cslug === item[0]).opfd_nid,
          ),
          opfv_cvalue: item[1],
        })
      } else {
        aDataWithNid.push({
          opfv_opfd_nid: Number(item[0]),
          opfv_cvalue: item[1],
        })
      }
    })

    //remover os campos que não foram preenchidos
    const aDataWithNidFiltered = aDataWithNid.filter((item) => {
      if (item.opfv_cvalue instanceof Object && item.opfv_cvalue.opfv_cvalue === "") {
        return false
      }
      if (
        item.opfv_cvalue instanceof Array &&
        item.opfv_cvalue[0] !== "" &&
        !(item.opfv_cvalue[0] instanceof Array && item.opfv_cvalue[0].length === 0)
      ) {
        return true
      }
      if (
        item.opfv_cvalue instanceof Object &&
        item.opfv_cvalue.opfv_cvalue !== undefined
      ) {
        return true
      }
      if (
        item.opfv_cvalue !== "" &&
        item.opfv_cvalue !== undefined &&
        !(item.opfv_cvalue instanceof Object)
      ) {
        return true
      }
      return false
    })

    if (aDataWithNidFiltered.length === 0) {
      return
    }

    fnSetAFilters(aDataWithNidFiltered)
    fnSetBFilterIsActive(true)
    await fnApplyFilter(aDataWithNidFiltered)
    cb && cb()
  }
  const fnApplyFilter = useCallback(
    async (aDataWithNidFiltered, cb) => {
      // const url = `visible_fields=1&show_done=1&filters=${JSON.stringify(
      //   aDataWithNidFiltered,
      // )}`
      fnSetOparams({
        page: 1,
        bDone: true,
        aFilters: aDataWithNidFiltered,
      })
    },
    [oCurrentBoard]
  )

  function fnCleanUpFilters(cb = null) {
    fnSetAFilters(() => [])
    fnSetOFilterData(() => { })
    fnSetOparams({
      page: 1,
      bDone: false,
      aFilters: [],
    })
    cb && cb()
  }
  function fnCloseFilterModa() {
    fnSetBFilterModalIsOpen(() => false)
  }
  function fnOpenFilterModal() {
    fnSetBFilterModalIsOpen(() => true)
  }
  const value = useMemo(() => {
    return {
      aFilters,
      bFilterIsActive,
      oFilterData,
      bFilterModalIsOpen,
      fnSetAFilters,
      fnPrepareFilters,
      fnCleanUpFilters,
      fnCloseFilterModa,
      fnOpenFilterModal,
      fnSetOCurrentBoard,
      fnApplyFilter,
    }
  }, [aFilters, bFilterIsActive, oFilterData, oCurrentBoard])

  return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>
}
